import {
    AccountRoleType,
    BalanceType,
    CreditCardAccount,
    CreditCardStatus,
    CustomerRole,
    KredittbankenAccountStatus,
} from '@generated-types';

export const v4CreditAccountMock1: CreditCardAccount = {
    accountId: '2509617',
    productName: 'Kredittbanken Visa',
    accountNumber: '1524996327',
    balances: [
        {
            type: BalanceType.AVAILABLE,
            amount: 17267.23,
        },
    ],
    billingSummary: {
        kidNumber: '015249963271',
        paymentDueDay: 10,
        paymentDueDate: undefined,
        paymentBankAccountNumber: '42024603940',
    },
    accountRoles: [
        {
            customerName: 'Uemosjonell Rype',
            customerNumber: '19907699326',
            accountRoleType: AccountRoleType.DEBTOR,
        },
        {
            customerName: 'Possessiv Forelder',
            customerNumber: '15909197179',
            accountRoleType: AccountRoleType.CO_DEBTOR,
        },
    ],
    interestsRates: {
        nominalInterestRate: 0.0,
        effectiveInterestRate: undefined,
    },
    status: KredittbankenAccountStatus.NORMAL,
    cards: [
        {
            id: '4563711',
            eikaCardId: 'MDE1MjQ5OTYzMjdfNDQxMzUzKsSSxJPEgjAzXzHEmDU5MDkxOTcxNzlfQ1JFRElU',
            cardNumber: '441353******5203',
            expires: { month: 6, year: 2027 },
            status: CreditCardStatus.NORMAL,
            product: {
                code: 'KREDITTBANKEN_VISA',
                name: 'Kredittbanken Visa',
            },
            activated: true,
            cardHolder: {
                firstName: 'Possessiv',
                lastName: 'Forelder',
                role: CustomerRole.SUPPLEMENTARY_CARDHOLDER,
                customerNumber: {
                    value: '15909197179',
                },
            },
            allowedCardActions: {
                payBillFromCard: false,
                transferFromCard: false,
            },
            userIsCardOwner: false,
            allowedOperations: {
                block: true,
                unblock: false,
                reorder: false,
                getVirtualCard: true,
                getPin: true,
                getUserLimit: true,
                setWallets: true,
                getChangeLimit: true,
                canTransfer: true,
                canPayBill: true,
            },
        },
    ],
    creditLimit: 20_000,
};
